import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { SurveyLinkListRequest, SurveyLinkListResponse } from "./types";

export const surveyLinkListService = (params: SurveyLinkListRequest) =>
  RestAPIClient.call<SurveyLinkListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      params,
      requireAuthentication: true,
    },
  });
